const ITEMS = [
  "Ladies' Wear",
  "Gents' Wear",
  "Footwear",
  "Innerwear",
  "Bags & Accessories",
  "Boutique & Alterations",
  "Pillows & Mattresses",
  "Free Delivery within 5 KM",
];

export const Marquee = () => (
  <div
    className="overflow-hidden border-b border-white/10 bg-charcoal-surface py-5"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center shrink-0">
              <span className="font-display italic text-lg sm:text-xl text-cream/45 px-7 whitespace-nowrap">
                {item}
              </span>
              <span className="text-gold/60 text-xs">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
